import { useRef } from 'react';

import container from '../awilix-container';

export default function useBlocRef(blocName) {
  const ref = useRef(null);

  if (!ref.current) {
    ref.current = container.resolve(blocName);
  }

  return ref;
}
